import _ from "lodash";
import React from "react";

// third party
import classNames from "classnames";

// scss
import classes from "./Sidebar.scss";

const getSidebarOptions = params => {
  const { displayPrompts } = params;

  const promptCountClass = classNames("text-subtitle-2", classes.promptsCount);

  const root = {
    key: "root",
    children: [],
  };

  const childOptions = _.reduce(
    displayPrompts,
    (result, prompt) => {
      const { id, depth, label, parent, children = [] } = prompt;

      if (!parent) root.children.push(id);

      const suffix =
        depth === 2 ? (
          <div className={promptCountClass}>{_.size(children)}</div>
        ) : null;

      result.push({
        key: id,
        title: label,
        tier: depth > 2 ? 2 : 1,
        parent: parent || "root",
        children,
        suffix,
      });

      return result;
    },
    []
  );

  return [root, ...childOptions];
};

const Sidebar = props => {
  const {
    displayPrompts,
    selectedSidebarItem,
    setSelectedSidebarItem,
    sidebarScrollRef,
  } = props;

  const sidebarOptions = getSidebarOptions({
    displayPrompts,
  });

  // if every option is tier 1 and has root as parent then it is the old prompt structure
  const isOldPromptStructure = _.every(
    sidebarOptions,
    ({ key, parent }) => key === "root" || parent === "root"
  );

  return (
    <div className={classes.sidebarContainer}>
      {_.map(sidebarOptions, (sidebarOption, index) => {
        const { key, title } = sidebarOption || {};
        if (!title) return null;

        const isLastItem = _.size(sidebarOptions) - 1 === index;

        const showSeparator =
          !isOldPromptStructure &&
          (isLastItem ||
            _.get(sidebarOptions?.[index + 1], "parent") === "root");

        return (
          <SidebarOption
            key={key}
            isSelected={selectedSidebarItem === key}
            sidebarScrollRef={sidebarScrollRef}
            isLastItem={isLastItem}
            sidebarOption={sidebarOption}
            showSeparator={showSeparator}
            setSelectedSidebarItem={setSelectedSidebarItem}
          />
        );
      })}
    </div>
  );
};

const SidebarOption = ({
  isSelected,
  isLastItem,
  sidebarScrollRef,
  sidebarOption,
  showSeparator,
  setSelectedSidebarItem,
}) => {
  const { tier, title, key, children } = sidebarOption || {};
  const isHeading = tier === 2;

  const optionClass = classNames({
    [classes.sidebarOption]: true,
    ["heading-6"]: isHeading,
    [classes.sidebarHeader]: isHeading,
    [classes.activeSidebarOption]: isSelected,
  });

  const separatorClass = classNames({
    [classes.separator]: true,
    [classes.marginBottom32]: isLastItem,
  });

  return (
    <>
      <div
        ref={isSelected ? sidebarScrollRef : null}
        onClick={() => setSelectedSidebarItem(key)}
        className={optionClass}
        onKeyDown={e =>
          (e.key === "Enter" || e.key === " ") && setSelectedSidebarItem(key)
        }
        tabIndex={0}
      >
        {isSelected ? (
          <div className={classes.activeOptionLeftBorder}></div>
        ) : null}

        <div className={classes.title}>{title}</div>

        {tier === 1 ? (
          <div className={classes.childrenCount}>{_.size(children)}</div>
        ) : null}
      </div>
      {showSeparator ? <div className={separatorClass} /> : null}
    </>
  );
};

export default Sidebar;
